import type { Components, Theme } from '@mui/material'

type MuiMenuItemSettings = Components<Omit<Theme, 'components'>>['MuiMenuItem']

export const MuiMenuItem: MuiMenuItemSettings = {
  styleOverrides: {
    root: {
      borderRadius: '8px',
    },
  },
}
